import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import { memo } from 'react';
import { Button } from 'components/mui/common/Button';
import type { IconNames } from 'components/mui/common/Icon';
import { Icon } from 'components/mui/common/Icon';

export interface CustomButtonProps {
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
  startIcon?: IconNames;
  endIcon?: IconNames;
  dataTestId?: string;
}

const CustomButtonBase = forwardRef<HTMLButtonElement, CustomButtonProps>(({ onClick, disabled, startIcon, endIcon, children, dataTestId }, ref) => {
  return (
    <Button
      ref={ref}
      variant="outlined"
      size="small"
      startIcon={startIcon && <Icon icon={startIcon} />}
      endIcon={endIcon && <Icon icon={endIcon} />}
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}>
      {children}
    </Button>
  );
});

export const CustomButton = memo(CustomButtonBase) as typeof CustomButtonBase;
